@if (canReorderActivities) {
  <button mat-menu-item (click)="onSortActivities.emit()" class="reorder-activity-btn">{{'folder_view-reorder-activities' | translate}}</button>
}
@if (hasMenuAccess() && canCreateActivity) {
  <button mat-menu-item (click)="onCreateActivity.emit()" class="create-activity-btn">{{'folder_view-create_button' | translate}}</button>
}
@if (hasMenuAccess() && !isLti()) {
  <button mat-menu-item (click)="editFolder()" class="edit-course-btn">{{'course-menu_edit-course' | translate}}</button>
}
@if (hasMenuAccess() && !isLti()) {
  <button mat-menu-item (click)="manageUsers()" class="manage-users-btn">{{'course-menu_manage-users' | translate}}</button>
}
@if (hasMenuAccess() && !isLti()) {
  <button mat-menu-item (click)="onInvite.emit()" class="invite-btn">{{'common_invite' | translate}}</button>
}
